import React, { useEffect, useState } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { useDispatch, useSelector } from "react-redux";
import { viewCabRequestList } from "../../Redux/Actions/cabRequestActions";
import { columnsCabs } from "../../Global Functions/columnsAntd";

const ListCabRequests = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const dispatch = useDispatch();
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const fetchDetails = (page, limit) => {
    const payload = {
      page,
      limit,
    };
    dispatch(viewCabRequestList(payload));
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { cabs } = useSelector((state) => state.cabs || {});

  useEffect(() => {
    if (cabs?.total) {
      setPagination((prevData) => ({ ...prevData, total: cabs.total }));
    }
  }, [cabs]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  return (
    <TableComponent
      h3heading="Cab Requests"
      pagination={pagination}
      onChange={handleTableChange}
      columns={columnsCabs(canEdit)}
      buttonhead2={canAdd ? "Add Cab Category" : null}
      navigateTo2={canAdd ? "/cab_settings/add" : null}
      dataSource={Array.isArray(cabs?.data) ? cabs.data : []}
    ></TableComponent>
  );
};

export default ListCabRequests;
